<template>
  <div class="filter-container">
    <v-expansion-panels
      class="pt-3"
      flat
    >
      <v-expansion-panel
        @change="focusExpansionPanelContent"
        class="grey lighten-2"
      >
        <v-expansion-panel-header>
          <h3 class="text-subtitle-2">Datakvalitet</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="grey lighten-3">

          <p
            id="expansion-panel-data-quality"
            tabindex="-1"
            class="mt-4 pa-1"
          >{{filterIsHidden ? options.notAvailableText : options.description}}</p>

          <div v-if="!filterIsHidden">

            <v-select
              class="data-quality-time-mode-select"
              @change="selectModeChanged"
              label="Tidsmodus for datakvalitet"
              v-model="qualityTypeOptions.value"
              :items="qualityTypeOptions.options"
              filled
              flat
            ></v-select>

            <div
              v-if="useSeasonFiltering"
              class="pb-4"
            >
              <v-checkbox
                v-for="(season, index) in seasons"
                :key="index"
                hide-details
                v-model="season.checked"
                :label="season.title"
                @change="updateFilter"
                class="ma-0 ml-1 data-quality-time-mode-select"
              ></v-checkbox>              
              <v-divider class="mt-4"></v-divider>
            </div>

            <template v-if="toYear !== '' && fromYear !== '' && show">

              <filter-data-quality-slider
                v-model="completenessValue"
                title="Maks andel manglende data (%)"
                @input="updateFilter"
                @filter-disabled="resetCompletenessFilter"
                @filter-enabled="useCompletenessFilter = true"
                :description="options.missingDataFilterDescription"
                :disabled="fromYear == '' || toYear == ''"
              />

              <filter-data-quality-slider
                v-model="correctedValue"
                title="Maks andel korrigerte data (%)"
                @input="updateFilter"
                @filter-disabled="resetCorrectedFilter"
                @filter-enabled="useCorrectedFilter = true"
                :description="options.correctedDataFilterDescription"
                :disabled="fromYear == '' || toYear == ''"
              />              
            </template>

          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import MapService from "../../services/MapService";
import { mapState, mapActions } from "vuex";
import FilterDataQualitySlider from './FilterDataQualitySlider.vue';

export default {
  name: "FilterDataQuality",
  components: { FilterDataQualitySlider },
  data () {
    return {
      value: [],
      qualityTypeOptions: {
        value: "Hele år",
        options: ["Hele år", "Sesonger"]
      },
      filterIsOpen: false,
      completenessValue: 100,
      correctedValue: 100,
      mode: "Er lik",
      filterIsSet: false,
      vannforingIsSelected: false,
      showFirstDescription: false,
      showSecondDescription: false,
      seasons: [
        {
          name: "vaar",
          title: "Vår (mars, april, mai)",
          checked: false
        },
        {
          name: "sommer",
          title: "Sommer (juni, juli, august)",
          checked: false
        },
        {
          name: "host",
          title: "Høst (september, oktober, november)",
          checked: false
        },
        {
          name: "vinter",
          title: "Vinter (desember, januar, februar)",
          checked: false
        }
      ],
      useCompletenessFilter: false,
      useCorrectedFilter: false
    };
  },
  computed: {
    ...mapState(["selectedMaaleParameter", "fromYear", "toYear", "yearFilterMode"]),
    filterIsHidden: function () {
      return !this.vannforingIsSelected || this.fromYear === null || this.toYear === null || this.yearFilterMode.id !== 'full';      
    },
    useSeasonFiltering: function () {
      return this.qualityTypeOptions.value === 'Sesonger';
    }
  },
  watch: {
    selectedMaaleParameter: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal.includes("Vannføring")) {
          this.vannforingIsSelected = true;
        } else {
          this.vannforingIsSelected = false;
          this.resetFilter();
        }
      }
    },
    toYear: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal == null) {
          this.resetFilter();
        } else {
          if (this.filterIsSet) {
            this.updateFilter();
          }

        }        
      }
    },
    fromYear: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal == null) {
          this.resetFilter();
        } else {
          if (this.filterIsSet) {
            this.updateFilter();
          }
        }
      }
    },
    yearFilterMode: function (newVal, oldVal) {
      if (newVal !== oldVal) {        
        if (newVal !== null && newVal.id === 'parts') {
          this.resetFilter();
        }                
      }
    }
  },
  props: {
    title: String,
    parameter: String,
    options: Object,
    show: Boolean
  },
  methods: {
    ...mapActions(["setChartDateRange", "setFilterValue"]),
    selectModeChanged: function (evt) {
      this.mode = evt;
      this.filterIsSet = false;
      this.updateFilter();
    },
    resetFilter: function () {
      this.qualityTypeOptions.value = "Hele år";
      this.completenessValue = 100;
      this.filterIsSet = false;
      this.correctedValue = 100;
      this.setFilterValue({
        filterFieldName: this.parameter,
        filterQueryString: null
      });
    },
    resetCompletenessFilter: function () {
      this.useCompletenessFilter = false;
      this.completenessValue = 100;      
      if (!this.useCompletenessFilter && !this.useCorrectedFilter) {
        this.setFilterValue({
          filterFieldName: this.parameter,
          filterQueryString: null
        });
      } else {
        this.updateFilter();
      }
    },
    resetCorrectedFilter: function () {
      this.useCorrectedFilter = false;
      this.correctedValue = 100;
      if (!this.useCompletenessFilter && !this.useCorrectedFilter) {
        this.setFilterValue({
          filterFieldName: this.parameter,
          filterQueryString: null
        });
      } else {
        this.updateFilter();
      }
    },    
    focusExpansionPanelContent: function () {
      if (!this.filterIsOpen) {
        setTimeout(() => {
          document.getElementById('expansion-panel-data-quality').focus()
        }, 100)
      }
      this.filterIsOpen = !this.filterIsOpen;


    },
    updateFilter: function () {
      let maxMissingData = this.useCompletenessFilter ? 1.0 - this.completenessValue / 100 : 0;
      let maxUncorrected = this.useCorrectedFilter ? 1.0 - this.correctedValue / 100 : 0;

      MapService
        .getTimeseriesWithCompleteness({
          fromYear: this.fromYear,
          toYear: this.toYear,
          useSeasons: this.qualityTypeOptions.value == "Sesonger",
          seasons: this.seasons,
          maxMissingData: maxMissingData,
          maxUncorrected: maxUncorrected,
          yearFilterMode: this.yearFilterMode
        })
        .then(result => {
          this.setFilterValue({
            filterFieldName: this.parameter,
            filterQueryString: result
          });
          this.filterIsSet = true;
        });
    }
  },
  created: function () {
    this.$eventHub.$on("reset-all-filters", this.resetFilter);
  }
};
</script>

<style>
.data-quality-time-mode-select:not(.v-input--is-focused) .v-input__slot {
  border-width: 4px 4px 4px 4px;
  border-color: #eeeeee;
  border-style: solid;
}
</style>

